import { useEffect, useState } from 'react';
import api from '../../../lib/apiClient';
import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'full_name', label: 'Candidate' },
  { key: 'vacancy_title', label: 'Vacancy' },
  { key: 'department', label: 'Department' },
  { key: 'stage', label: 'Stage' },
  { key: 'applied_on', label: 'Applied On' },
  { key: 'offered_salary', label: 'Offered Salary', align: 'right', type: 'money' },
];

export function RecruitmentPipelineReport() {
  const { lists } = useConfig();
  const [orgUnitOptions, setOrgUnitOptions] = useState<ReportOption[]>([]);

  useEffect(() => {
    api
      .get<{ id: number; unit_name: string }[]>('/org-units')
      .then((res) => setOrgUnitOptions(res.data.map((u) => ({ value: String(u.id), label: u.unit_name }))));
  }, []);

  return (
    <ReportView
      title="Recruitment Pipeline"
      description="Every candidate across every vacancy, with pipeline stage and offer details."
      endpoint="/reports/hr/recruitment"
      columns={COLUMNS}
      filters={['status', 'category', 'dateRange']}
      statusOptions={listOptions(lists, 'candidate_stage')}
      categoryOptions={orgUnitOptions}
      listColumns={{ stage: 'candidate_stage' }}
    />
  );
}
